import { PureComponent } from 'react';
import { connect } from 'react-redux';

class BlogArticleComponent extends PureComponent {

    constructor(props) {
        super(props);

    }

    render() {
        var blogLink = this.props.blog.link;
        var blogImage = this.props.blog.image;
        var blogTitle = this.props.blog.title;

        return (<div className="blog-card card">
            <div className="card-body">
                <a href={blogLink}><img className="img-fluid" src={blogImage} alt="AvePDF Blog Article" width="542" height="352" /></a>
                <a className="blog-title" href={blogLink}> {blogTitle}</a>
            </div>
        </div>);
    }
}



const mapState = ({ tool }) => {
    return {
        language: tool.lang
    };
}
const BlogArticle = connect(mapState)(BlogArticleComponent);
export default BlogArticle;